export const environment = {
    production: false,
    // _proxy_dynamo_cms: 'http://localhost:8080/',
    _proxy_dynamo_cms: 'https://dynamo-proxy.skillagentur.com/',
};
